import { render, staticRenderFns } from "./allinpay_order_check_list.vue?vue&type=template&id=6c15b158&scoped=true"
import script from "./allinpay_order_check_list.vue?vue&type=script&lang=js"
export * from "./allinpay_order_check_list.vue?vue&type=script&lang=js"
import style0 from "./allinpay_order_check_list.vue?vue&type=style&index=0&id=6c15b158&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c15b158",
  null
  
)

export default component.exports